import Services from 'store/Services';

import { handleErrorsMiddleware } from './handleErrorsMiddleware';
import { handleFillsGraphConfigChangeMiddleware } from './handleFillsGraphConfigChangeMiddleware';

export const clickstreamMiddleware = (services: Services) => [
    handleErrorsMiddleware(services.clickstreamService),
    handleFillsGraphConfigChangeMiddleware(services.clickstreamService),
];
